import { render, staticRenderFns } from "./repay-records.vue?vue&type=template&id=766689c3"
import script from "./repay-records.vue?vue&type=script&lang=ts"
export * from "./repay-records.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports